import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";

const BASE_URL = "https://www.lpufootballshirts.pl";

export function SEOHelmet() {
  const { pathname } = useLocation();
  const canonical = `${BASE_URL}${pathname}`;

  const noindexExact = [
    "/auth",
    "/reset-password",
    "/reset-password/new",
    "/wiadomosci",
    "/admin",
    "/add-kit",
  ];
  const isNoindex =
    noindexExact.includes(pathname) ||
    pathname.startsWith("/profile/") ||
    pathname.startsWith("/collection/");

  return (
    <Helmet>
      <link rel="canonical" href={canonical} />
      <meta property="og:url" content={canonical} />
      {isNoindex && (
        <meta name="robots" content="noindex, nofollow" />
      )}
    </Helmet>
  );
}
